/**
 * Utility function to generate participant avatar text
 * Rule: {First character of First Name}{First character of Middle Name}{First character of Last Name}
 * If Middle Name is empty, add a dash: {First character of First Name}-{First character of Last Name}
 */
export function getParticipantAvatarText(participant: {
  first_name?: string;
  middle_name?: string;
  last_name?: string;
}, isMonitor: boolean = false, subjectId: string = ''): string {
  if (isMonitor) {
    return subjectId.charAt(0).toUpperCase() || 'N/A';
  }

  if (!participant?.first_name || !participant?.last_name) {
    return '';
  }

  const firstInitial = participant.first_name.charAt(0).toUpperCase();
  const lastInitial = participant.last_name.charAt(0).toUpperCase();
  
  if (participant.middle_name && participant.middle_name.trim()) {
    const middleInitial = participant.middle_name.charAt(0).toUpperCase();
    return `${firstInitial}${middleInitial}${lastInitial}`;
  } else {
    return `${firstInitial}-${lastInitial}`;
  }
} 